<a class="prf-footer-logo-wrapper" [href]="logo.href">
  <img [ngSrc]="logo.image.src" class="prf-footer-logo" [alt]="logo.image.alt" [width]="logo.image.width" [height]="logo.image.height" />
</a>
